export default __webpack_public_path__ + "static/media/mcaccess.260f4526.png";